import * as moment from 'moment';
import * as queryString from 'query-string';
import API from '../api';

interface AvailabilitiesParams {
  start: string;
  end: string;
  vehicle_type_id?: number;
  offset?: number;
  limit?: number;
}

/**
 * Get a list of availabilities
 */
const getAvailabilities = (params: AvailabilitiesParams) => (dispatch) => {
  return API.request(`/availabilities?${queryString.stringify(params)}`)
    .then((response) => response.json())
    .then((response) => {
      return response;
    });
};

export { getAvailabilities };
